module.exports = __webpack_public_path__ + "img/word.ba2b28a8.jpg";